import { render, staticRenderFns } from "./admin-message-list.vue?vue&type=template&id=0abfea9a&scoped=true"
import script from "./admin-message-list.vue?vue&type=script&lang=js"
export * from "./admin-message-list.vue?vue&type=script&lang=js"
import style0 from "./admin-message-list.vue?vue&type=style&index=0&id=0abfea9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abfea9a",
  null
  
)

export default component.exports